import FooterNav from '@modules/layout/components/footer-nav'
//import MedusaCTA from '@modules/layout/components/medusa-cta'
import { GoogleAnalytics } from "nextjs-google-analytics";

const Footer = () => {
  return (
    <footer className="flex flex-col">
      <FooterNav />
      <GoogleAnalytics gaMeasurementId="G-TXG99VZB7B" />
    </footer>
  )
}

export default Footer
